/**
 * JavaScript Document
 * Version: 1.0.0
 * Date: 4/20/2020
 * Author: Liu Changkun
 * Copyright: www.east.net
 */
import http, { formConfig } from "@/utils/http";
const url = action => `/log/${action[0]}`;

export default class LOG {
  static LIST(params) {
    return http.get(url`list`, { params });
  }
  static DELETE(data) {
    return http.post(url`delete`, data, formConfig);
  }
}
